import { Address } from "features/organizations/sites/models/sites-models";
import { validateAddress, validateEmail, validateHours, validateSiteLongitudeLatitudeDecimal, validateText } from "../../../../validators/inputValidators";

/**
 * Parses an address line and returns an Address object.
 *
 * @param addressLine - The address line to parse.
 * @returns The parsed Address object with properties country, state, and region.
 */
export const addressParss = (addressLine: string): Address => {
    const addressValues = addressLine.split(",");
    return {
        country: (addressValues[0] || "").trim(),
        state: (addressValues[1] || "").trim(),
        region: (addressValues[2] || "").trim(),
        latitude: '0',
        longitude: '0'
    }
}

/**
 * Validates a customer form data.
 *
 * @param formData - The customer form data to validate.
 * @returns An object containing validation errors for each form field.
 */
export const validateCustomerForm = (formData: Record<string, string>): Record<string, string> => {
    const errors: Record<string, string> = {};
    errors.customerName = validateText(formData.customerName);
    errors.contact = (formData.contact)? validateEmail(formData.contact):"";
    errors.metsoContact = validateEmail(formData.metsoContact);
    return errors;
};

/**
 * Validates a site form data.
 *
 * @param formData - The site form data to validate.
 * @returns An object containing validation errors for each form field.
 */
export const validateSiteForm = (formData: Record<string, string>): Record<string, string> => {
    const errors: Record<string, string> = {};
    errors.siteName = validateText(formData.siteName);
    errors.address = validateAddress(formData.address);
    errors.contact = (formData.contact) ? validateEmail(formData.contact) : "";
    errors.metsoContact = validateEmail(formData.metsoContact);
    errors.latitude = validateSiteLongitudeLatitudeDecimal(formData.latitude);
    errors.longitude = validateSiteLongitudeLatitudeDecimal(formData.longitude);
    errors.utcOffsetHours = validateHours(formData.utcOffsetHours);
    return errors;
};

export enum ModalTypes {
    CustomerModal,
    SiteModal,
    AssetModal,
    AssetSectionModal
}
